import { ReactNode } from "react";

type Props = {
  title: string;
  children: ReactNode;
  footer?: ReactNode;
};

/** Generic statistics indicator card with title, content and footer. */
export function StatsCard({ title, children, footer }: Props) {
  return (
    <div className="rounded-sm bg-white p-5 md:p-8 shadow-xs border-none h-full flex flex-col">
      <h5 className="text-2xl md:text-2xl font-bold text-[#00B862]">{title}</h5>
      <div className="mt-4 text-sm xl:text-base">{children}</div>
      {footer && (
        <div className="mt-auto  pt-4 text-right text-base xl:text-lg font-semibold text-[#00A356]">{footer}</div>
      )}
    </div>
  );
}












